<template>
  <section class="vbox">
    <section class="scrollable wrapper">
      <div class="content-header">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '#' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>统计</el-breadcrumb-item>
          <el-breadcrumb-item>会员充值</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content-main">
        <el-form :inline="true" size="small">
          <el-row>
            <el-col :span="3"> <el-input placeholder="单据号" v-model="queryParam.billNumber" size="small" clearable></el-input></el-col>
            <el-col :span="3" style="margin-left:5px"><el-input  placeholder="会员编号" v-model="queryParam.number" size="small" clearable></el-input></el-col>
            <el-col :span="3" style="margin-left:5px"><el-input  placeholder="商家名称" v-model="queryParam.merchartName" size="small" clearable></el-input></el-col>
            <el-col :span="8" style="margin-left:5px">
              <el-date-picker
                v-model="queryParam.date"
                size="small" 
                type="daterange"
                align="right"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"                
                end-placeholder="结束日期"
                @change="dateFormat"
                >
              </el-date-picker>
            </el-col>
            <el-col :span="2" style="margin-left:5px"><el-button type="primary" v-on:click="Search" size="small" >查询</el-button></el-col>
          </el-row>
        </el-form>
        <el-table :data="items" style="width: 100%">
          <el-table-column  prop="BillNumber" :show-overflow-tooltip="true" fixed="left" label="单据号"> </el-table-column>
          <el-table-column  prop="number"  label="会员编号"> </el-table-column>
          <el-table-column  prop="MemberName"  label="会员名称"> </el-table-column>
          <el-table-column  prop="Mobile" width="120px" label="手机号"> </el-table-column>
          <el-table-column  prop="MerchartName"  label="商家"> </el-table-column>
          <el-table-column  prop="PaidInfo_ReceivableAmount"  label="充值金额"> </el-table-column>
          <el-table-column  prop="PaidInfo_ReceiptAmount"  label="实收金额"> </el-table-column>
          <el-table-column  prop="CardName" :show-overflow-tooltip="true" label="充值卡"  > </el-table-column>
          <el-table-column  prop="UserAccount"  label="操作员"   ></el-table-column>
          <el-table-column  prop="CreateTime" :show-overflow-tooltip="true"  width="110px" label="操作时间"> </el-table-column>
        </el-table>
        <el-pagination
          :hide-on-single-page="true"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParam.pageIndex"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryParam.pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="queryParam.totalCount">
        </el-pagination>
      </div>   
    </section>
  </section>
</template>
<script  type='text/ecmascript-6'>
  export default {
    props:{
    },
    data (){
      return {        
        items:[],
        queryParam: {
          pageIndex: 1,
          pageSize: 10,
          sort: ' CreateTime desc ',
          totalCount:10,
          billNumber:'',
          number:'',
          merchartName:'',
          beginTime:'',
          endTime:'',
          date:''
        }
      }
    },
    computed:{
    },
    mounted(){
      this.GetData();
    },
    methods:{     
      Search:function(){
        this.pageIndex = 1;
        this.GetData();
      },
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/Statistical/MemberRechargeNote',
          params: that.queryParam
        }).then(function (resp) {
          that.queryParam.totalCount = resp.data.totalCount
          that.items = resp.data.data
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      handleSizeChange(val) {
        this.queryParam.pagesize = val 
        this.queryParam.pageIndex = 1
        this.GetData()
      },
      handleCurrentChange(val) {
        this.queryParam.pageIndex = val 
        this.GetData()
      },
      dateFormat(picker){
        if(picker==null){
          this.queryParam.beginTime = ''
          this.queryParam.endTime = ''
        }else{
          this.queryParam.beginTime = picker[0]
          this.queryParam.endTime = picker[1]
        }
      }
    },
    components:{    
       
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px   

</style>